module.exports = __webpack_public_path__ + "img/car_blue.9ca9a0ee.png";